
import React, { Component } from 'react';
import { map } from 'lodash';
import { Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';
import { InputPhoneNumberMispari } from '../../lib/forms';

class OptionsForwardedTo extends Component {

  render(){
    const { wasAlreadyForwardedTo, translate, input, values, meta: { touched, error } } = this.props;
    return(
      <div className="custom-controls-stacked">
      {map(wasAlreadyForwardedTo, (call, key) => {
          return (
            <label className="custom-control custom-radio" key={key}>
            <input {...input} className="custom-control-input" type="radio" checked={values[input.name] === String(call)} value={`${call}`} />
            <span className="custom-control-indicator"></span>
            <span className="custom-control-description">{PhoneNumberFormat(call)}</span>
            </label>
          )
        })}
        <label className="custom-control custom-radio mb-0 custom-control-md-down">
          <input {...input}  className="custom-control-input" type="radio" name="radio0" checked={values[input.name] === "newNumber"} value="newNumber"/>
          <span className="custom-control-indicator custom-control-indicator-center"></span>
          <span className="custom-control-description">
            <Field {...input}  name="newNumber" className="form-control"  component={ InputPhoneNumberMispari }  type="number" />
          </span>
        </label>
        {touched && error && <div><span className="text-danger">{translate(error)}</span></div>}
        </div>
    )
  }
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    values: getFormValues('mispari')(state) ||{},
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};

OptionsForwardedTo = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(OptionsForwardedTo);

export default OptionsForwardedTo;



// WEBPACK FOOTER //
// ./src/components/Mispari/OptionsForwardedTo.js